<section
  [id]="anchorId()"
  class="scroll-mt-4 overflow-hidden rounded-lg border bg-white transition-colors"
  [class.border-primary-300]="phase().isComplete || phase().isCurrent"
  [class.border-greyscale-200]="!phase().isComplete && !phase().isCurrent"
>
  <button
    type="button"
    (click)="expandToggled.emit()"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="anchorId() + '-steps'"
    class="flex w-full items-center gap-4 bg-transparent p-4 text-left transition-colors hover:bg-greyscale-50"
  >
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 text-paragraph-s-bold transition-colors"
      [class.border-primary-500]="phase().isComplete || phase().isCurrent"
      [class.bg-primary-500]="phase().isComplete"
      [class.text-white]="phase().isComplete"
      [class.text-primary-600]="phase().isCurrent && !phase().isComplete"
      [class.ring-4]="phase().isCurrent && !phase().isComplete"
      [class.ring-primary-100]="phase().isCurrent && !phase().isComplete"
      [class.border-greyscale-300]="!phase().isComplete && !phase().isCurrent"
      [class.text-greyscale-500]="!phase().isComplete && !phase().isCurrent"
    >
      @if (phase().isComplete) {
        <lucide-icon [name]="icon()" [size]="18" />
      } @else {
        {{ phase().position }}
      }
    </div>

    <div class="min-w-0 flex-1">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-heading-4 text-greyscale-950">
          {{
            "help.onboarding.journey.phases." + phase().phase + ".title"
              | transloco
          }}
        </h3>

        @if (phase().isComplete) {
          <span
            class="flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-paragraph-xs-med text-primary-700"
          >
            <lucide-icon name="award" [size]="12" />
            {{ "help.onboarding.journey.phaseState.done" | transloco }}
          </span>
        } @else if (phase().isCurrent) {
          <span
            class="rounded-full bg-warning-100 px-2 py-0.5 text-paragraph-xs-med text-warning-700"
          >
            {{ "help.onboarding.journey.phaseState.current" | transloco }}
          </span>
        }
      </div>

      <p class="mt-0.5 text-paragraph-xs-reg text-greyscale-600">
        {{
          "help.onboarding.journey.phases." + phase().phase + ".subtitle"
            | transloco
        }}
      </p>

      <div class="mt-2 flex items-center gap-3">
        <div
          class="h-1.5 w-full max-w-[200px] overflow-hidden rounded-full bg-greyscale-200"
        >
          <div
            class="h-full rounded-full bg-primary-500 transition-all duration-700 ease-out"
            [style.width.%]="(phase().completed / phase().total) * 100"
          ></div>
        </div>
        <span class="text-paragraph-xs-med text-greyscale-600">
          {{
            "help.onboarding.journey.stepsDone"
              | transloco
                : { completed: phase().completed, total: phase().total }
          }}
        </span>
      </div>
    </div>

    <lucide-icon
      name="chevron-down"
      [size]="20"
      class="shrink-0 text-greyscale-500 transition-transform duration-300"
      [class.rotate-180]="expanded()"
    />
  </button>

  @if (expanded()) {
    <div
      [id]="anchorId() + '-steps'"
      class="flex animate-slide-in-up flex-col gap-2 border-t border-greyscale-200 p-4"
    >
      @for (step of phase().steps; track step.key) {
        <app-journey-step-item
          [step]="step"
          [pending]="pendingStepKey() === step.key"
          (toggled)="stepToggled.emit($event)"
        />
      }
    </div>
  }
</section>
